module.exports = __webpack_public_path__ + "img/danamon.d932631f.png";